import { render, staticRenderFns } from "./EmployeeInformation.vue?vue&type=template&id=280b267c"
import script from "./EmployeeInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInformation.vue?vue&type=style&index=0&id=280b267c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports